import React from 'react';
import { capitalize } from 'lodash';

import { getReadableState } from 'common/state';
import { ExperimentStateLabel } from 'components/experiment-id';
import { PropertyRow } from 'components/layouts/rows';
import type { ExperimentStateAttribute } from 'domain/experiment/attribute';

type StateRendererProps = {
  attribute?: ExperimentStateAttribute;
  labelWidth?: string;
  label?: string;
  'data-name'?: string;
  rowVariant?: 'compact' | 'default';
};

export const StateRenderer: React.FC<StateRendererProps> = ({
  attribute,
  labelWidth = '100px',
  label,
  'data-name': dataName,
  rowVariant = 'default',
}) => {
  if (!attribute) {
    return null;
  }

  const state = attribute.value;

  return (
    <PropertyRow
      value={<ExperimentStateLabel state={state} label={getReadableState(state)} />}
      title={capitalize(getReadableState(state))}
      labelWidth={labelWidth}
      label={label}
      data-name={dataName}
      variant={rowVariant}
    />
  );
};
